<style lang="less" scoped></style>

<template>
  <div class="detail-container">
    <div class="detail-bread-crumb-div">
      <ZD-bread-crumb :bConfigList="pageConfig.logBreadCrumb"></ZD-bread-crumb>
    </div>
    <div class="detail-content-div">
      <div class="detail-content-header-div flex" style="justify-content:space-between;">
        <div class="left-page-title-div flex-1">广告位置名称：{{name}} </div>
        <div class="left-page-title-div"> <button class="common-empty-button" @click="resetForm">取 消</button></div>
      </div>
      <div class="detail-content-body-div flex-1">
        <el-table
          :data="tableData"
          border
          style="width: 100%"
          @selection-change="
            (sels) => {
              selections = sels;
            }
          "
        >
          <el-table-column type="selection" width="55"> </el-table-column>
          <el-table-column
            prop="createdByName"
            label="更新人"
            width="180"
            align="center"
          >
          </el-table-column>
          <el-table-column
            prop="createdWhen"
            label="更新时间"
            width="180"
            align="center"
          >
          </el-table-column>
          <el-table-column prop="type" label="更新操作" align="center">
          </el-table-column>
          <el-table-column prop="address" label="更新内容" align="center">
            <template slot-scope="scope">
              <el-button @click="handleClick(scope.row)" size="small"
                >查看</el-button
              >
            </template>
          </el-table-column>
        </el-table>
        <div class="list-pagination">
          <ZD-pagination
            :pagination="pagination"
            v-on:pageUpdate="getListData"
          ></ZD-pagination>
        </div>
      </div>

      <el-dialog title="查看" :visible.sync="dialogVisible" width="60%">
        <el-tabs v-model="activeName" type="card" @tab-click="tabClick">
          <el-tab-pane
            v-if="activeName == 'first'"
            label="参数编辑"
            name="first"
          >
            <div class="detail-form-parent-div">
              <div class="margin-bt-10" v-if="!isFlag">
                <div class="flex">
                  广告位置名称
                  <el-input
                    style="width:300px;"
                    v-model="oldDate.adName"
                    placeholder=""
                  ></el-input>
                  &emsp;<span style="font-size:20px;font-weight:800;"> > </span>&emsp;
                  <el-input
                    style="width:300px;"
                    v-model="newDate.adName"
                    placeholder=""
                  ></el-input>
                </div>
                <div class="flex">
                  广告轮播时间
                  <el-input
                    style="width:300px;"
                    v-model="oldDate.picSize"
                    placeholder=""
                  ></el-input>
                  &emsp;<span style="font-size:20px;font-weight:800;"> > </span>&emsp;
                  <el-input
                    style="width:300px;"
                    v-model="newDate.picSize"
                    placeholder=""
                  ></el-input>
                </div>
              </div>
            </div>
          </el-tab-pane>
          <el-tab-pane
            label="添加图片"
            v-if="activeName == 'addImg'"
            name="addImg"
          >
          </el-tab-pane>
          <el-tab-pane
            label="编辑图片"
            v-if="activeName == 'editImg'"
            name="editImg"
          >
          </el-tab-pane>
          <el-tab-pane
            label="添加替换图片"
            v-if="activeName == 'addReplaceImg'"
            name="addReplaceImg"
          >
          </el-tab-pane>
          <el-tab-pane
            label="编辑替换图片"
            v-if="activeName == 'editReplaceImg'"
            name="editReplaceImg"
          >
          </el-tab-pane>
          <el-tab-pane
            label="停用替换图片"
            v-if="activeName == 'stopImg'"
            name="stopImg"
          >
          </el-tab-pane>
        </el-tabs>
        <div style="font-size:20px; font-weight:800;" v-if="activeName != 'first'">位置{{ oldDate.advertAddressId }}</div>
        <el-form
          v-if="isFlag"
          :model="oldDate"
          ref="oldData"
          class="detail-form"
        >
          <div class="detail-form-parent-div" style="width:100%;">
            <div class="margin-bt-10">
              <div class="flex">
                <el-form-item
                  class="detail-from-input"
                  label="活动名称"
                  prop="showName"
                  label-width="200"
                >
                  <el-input
                    v-model="oldDate.pictureName"
                    disabled
                    clearable
                    size="small"
                    placeholder="请输入优惠券名称（20字以内）"
                    maxlength="20"
                  ></el-input>
                </el-form-item>
                <el-form-item
                  class="detail-form-logo detail-body-title"
                  label="优惠券图片"
                  label-width="200"
                >
                  <el-upload
                    class="upload-demo upload-logo"
                    action=""
                    :http-request="toUploadImg"
                    :on-exceed="handleExceed"
                    :on-preview="handleLogoPreview"
                    :on-remove="handleLogoRemove"
                    :file-list="logoFileList"
                    :limit="1"
                    :before-upload="beforeAvatarUpload"
                    list-type="picture"
                  >
                    <el-button size="small" disabled type="primary"
                      >点击上传</el-button
                    >
                    <div slot="tip" class="el-upload__tip">
                      只能上传 jpg / jpeg / bmp / gif / png
                      文件(仅1张)，且不超过1M
                    </div>
                  </el-upload>
                </el-form-item>
              </div>
            </div>

            <div class="margin-bt-10">
              <div>
                <div>
                  <el-form-item
                    class="detail-from-input"
                    label="启用时间"
                    prop="showName"
                    label-width="100"
                  >
                    <el-input
                    style="width:200px;"
                      disabled
                      v-model="oldDate.startTime"
                      clearable
                      size="small"
                      placeholder="请输入图片名称（20字以内）"
                      maxlength="20"
                    ></el-input>
                  </el-form-item>
                </div>

                <div>
                  <el-form-item
                    class="detail-from-input"
                    label="结束时间"
                    prop="ratedVoltage"
                    label-width="600"
                  >
                    <el-radio-group
                      v-model="filterType"
                      @change="filterTypeChange"
                      v-if="!addReplaceFlag"
                    >
                      <el-radio label="01">具体时间</el-radio>
                      <el-radio label="02">永久</el-radio>
                    </el-radio-group>
                    <div v-else>具体时间</div>
                    <br />
                    <el-input
                      disabled
                      style="width:130px;"
                      v-model="oldDate.endTime"
                      clearable
                      placeholder="请选择结束时间"
                      size="small"
                      maxlength="25"
                    ></el-input>
                  </el-form-item>
                </div>
              </div>
            </div>
            <div class="margin-bt-10">
              <div class="flex">
                <el-form-item
                  class="detail-from-input"
                  label="跳转地址"
                  prop="materialNo"
                >
                  <el-input
                    disabled
                    v-model="oldDate.pictureUrl"
                    clearable
                    placeholder="请输入50字以内跳转地址"
                    size="small"
                    maxlength="25"
                  ></el-input>
                  若无跳转,则填入"/"
                </el-form-item>
              </div>
              
                <el-form-item
                class="detail-from-input"
                label="备注"
                prop="ratedVoltage"
              >
              <div class="flex"> 
                <el-input
                  disabled
                  style="width:230px;"
                  maxlength="50"
                  v-model="oldDate.remark"
                  clearable
                  placeholder="50字以内备注"
                ></el-input>
                &emsp;<span v-if="activeName == 'editImg'" style="font-size:20px;font-weight:800;margin: 0 20px;"> > </span>&emsp;
                <el-input
                v-if="activeName == 'editImg'"
                  disabled
                  style="width:230px;"
                  maxlength="50"
                  v-model="newDate.remark"
                  clearable
                  placeholder="50字以内备注"
                ></el-input>
              </div>
              </el-form-item>
             
              
              
              
              <el-form-item
                class="detail-from-input"
                label="停用编辑"
                prop="ratedVoltage"
                v-if="activeName == 'stopImg' || activeName == 'editImg'"
              >
                  &emsp;<span v-if="activeName == 'stopImg' || activeName == 'editImg'" style="font-size:20px;font-weight:800;"> > </span>&emsp;停用
              </el-form-item>
            </div>
          </div>

          <div
            class="detail-form-parent-div"
            style="width:100%;"
            v-if="activeName == 'editReplaceImg'"
          >
            <div class="margin-bt-10">
              <div class="flex">
                <el-form-item
                  class="detail-from-input"
                  label="活动名称"
                  prop="showName"
                  label-width="200"
                >
                  <el-input
                    v-model="newDate.pictureName"
                    disabled
                    clearable
                    size="small"
                    placeholder="请输入优惠券名称（20字以内）"
                    maxlength="20"
                  ></el-input>
                </el-form-item>
                <el-form-item
                  class="detail-form-logo detail-body-title"
                  label="优惠券图片"
                  label-width="200"
                >
                  <el-upload
                    class="upload-demo upload-logo"
                    action=""
                    :http-request="toUploadImg"
                    :on-exceed="handleExceed"
                    :on-preview="handleLogoPreview"
                    :on-remove="handleLogoRemove"
                    :file-list="logoFileList"
                    :limit="1"
                    :before-upload="beforeAvatarUpload"
                    list-type="picture"
                  >
                    <el-button size="small" disabled type="primary"
                      >点击上传</el-button
                    >
                    <div slot="tip" class="el-upload__tip">
                      只能上传 jpg / jpeg / bmp / gif / png
                      文件(仅1张)，且不超过1M
                    </div>
                  </el-upload>
                </el-form-item>
              </div>
            </div>

            <div class="margin-bt-10">
              <div>
                <div>
                  <el-form-item
                    class="detail-from-input"
                    label="启用时间"
                    prop="showName"
                    label-width="200"
                  >
                    <el-input
                      disabled
                      v-model="newDate.startTime"
                      clearable
                      size="small"
                      placeholder="请输入图片名称（20字以内）"
                      maxlength="20"
                    ></el-input>
                  </el-form-item>
                </div>

                <div>
                  <el-form-item
                    class="detail-from-input"
                    label="结束时间"
                    prop="ratedVoltage"
                    label-width="600"
                  >
                    <el-radio-group
                      v-model="filterType"
                      @change="filterTypeChange"
                      v-if="!addReplaceFlag"
                    >
                      <el-radio label="01">具体时间</el-radio>
                      <el-radio label="02">永久</el-radio>
                    </el-radio-group>
                    <div v-else>具体时间</div>
                    <br />
                    <el-input
                      disabled
                      style="width:130px;"
                      v-model="newDate.endTime"
                      clearable
                      placeholder="请选择结束时间"
                      size="small"
                      maxlength="25"
                    ></el-input>
                  </el-form-item>
                </div>
              </div>
            </div>
            <div class="margin-bt-10">
              <div class="flex">
                <el-form-item
                  class="detail-from-input"
                  label="跳转地址"
                  prop="materialNo"
                >
                  <el-input
                    disabled
                    v-model="newDate.pictureUrl"
                    clearable
                    placeholder="请输入50字以内跳转地址"
                    size="small"
                    maxlength="25"
                  ></el-input>
                  若无跳转,则填入"/"
                </el-form-item>
              </div>
              <el-form-item
                class="detail-from-input"
                label="备注"
                prop="ratedVoltage"
              >
                <el-input
                  disabled
                  maxlength="50"
                  v-model="newDate.remark"
                  clearable
                  placeholder="50字以内备注"
                ></el-input>
              </el-form-item>
            </div>
          </div>
        </el-form>
        <!-- <span slot="footer" class="dialog-footer">
          <el-button @click="dialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="submit()">确 定</el-button>
        </span> -->
      </el-dialog>

      <div class=" flex-r-end">
        <!-- <button class="common-bg-button" @click="submitForm('detailForm')">
          提 交
        </button> -->
        <!-- <button class="common-empty-button" @click="resetForm">取 消</button> -->
      </div>
    </div>
  </div>
</template>

<script>
import pageConfig from "./page-config";
export default {
  data() {
    return {
      name: "",
      pageConfig,
      addReplaceFlag: false,
      listForm: {},
      isFlag: false,
      editFlag: false,
      activeName: "first",
      dialogVisible: false,
      tableData: [], // 表格数据
      selections: [], // 表格选项
      pagination: pageConfig.pagination,
      queryInfo: {}, //初始化数据
      filterType: "",
      logoFileList: [],
      oldDate: {},
      newDate: {},
      name:''
    };
  },
  created() {
    this.init();
  },
  methods: {
    handleClick(val) {
      this.dialogVisible = true;
      if (val.type == "参数编辑") {
        this.activeName = "first";
        this.isFlag = false;
        this.oldDate = val.oldData;
        this.newDate = val.newData;
      }
      if (val.type == "添加图片") {
        this.activeName = "addImg";
        this.isFlag = true;
        this.oldDate = val.oldData;
        this.newDate = val.newData;
      }
      if (val.type == "编辑图片") {
        this.activeName = "editImg";
        this.isFlag = true;
        this.oldDate = val.oldData;
        this.newDate = val.newData;
      }
      if (val.type == "添加替换图片") {
        this.activeName = "addReplaceImg";
        this.isFlag = true;
        this.oldDate = val.oldData;
        this.newDate = val.newData;
      }
      if (val.type == "编辑替换图片") {
        this.activeName = "editReplaceImg";
        this.isFlag = true;
        this.oldDate = val.oldData;
        this.newDate = val.newData;
      }
      if (val.type == "停用替换图片") {
        this.activeName = "stopImg";
        this.isFlag = true;
        this.oldDate = val.oldData;
        this.newDate = val.newData;
      }
    },
    tabClick(val) {
      console.log(val);
      this.activeName = val.name;
      if (val.name == "first") {
        this.isFlag = true;
      } else {
        this.isFlag = false;
        if (val.name == "addReplaceImg") {
          this.addReplaceFlag = true;
        }
      }
    },
    checkSelectOne(selections) {
      if (selections.length < 1) {
        this.$U.error("请选择需要操作的对象");
        return false;
      }
      if (selections.length > 1) {
        this.$U.error("只能选择一个操作的对象");
        return false;
      }
      return true;
    },
    //获取数据
    init() {
      this.name = JSON.parse(localStorage.getItem("advUpdateLog")).adName
      this.getListData(this.pagination, true);
    },

    // 获取表格数据
    getListData(pagination, reload = false) {
      let _ = this;
      _.$U.showLoading(_);
      _.queryInfo.pageNum = pagination.current - 1;
      if (reload) {
        _.pagination.current = 1;
        _.queryInfo.pageNum = 0;
      }
      _.queryInfo.pageSize = pagination.pageSize;
      _.queryInfo.corpNo = _.$store.state.corpNo;
      _.queryInfo.couponNo = _.$route.query.couponNo;
      _.queryInfo.logId = JSON.parse(localStorage.getItem("advUpdateLog")).adNo;
      _.$H
        .post(_, _.$A.coupon.advertGetEidtHistory, _.queryInfo)
        .then((res) => {
          _.tableData = res.data.data.content || [];
          _.pagination.total = res.data.data.totalElements || 0;
          _.$U.hideLoading(_);
        });
    },
    filterTypeChange() {},
    //上传logo图片
    toUploadLogoImg(param) {
      this.logoFile = param.file;
    },
    handleExceed(files, fileList) {
      this.$message.warning(
        `当前限制选择 1 个文件，本次选择了 ${
          files.length
        } 个文件，共选择了 ${files.length + fileList.length} 个文件`
      );
      // console.log(fileList);
    },
    //清楚logo图片
    handleLogoRemove(file, fileList) {
      this.detailForm.pileImgUrl = "";
      this.logoFile = null;
    },
    //预览logo
    handleLogoPreview(file) {
      console.log(file);
    },
    //上传logo图片限制
    beforeAvatarUpload(file) {
      let logoType = false;
      if (
        file.type === "image/jpeg" ||
        file.type === "image/jpg" ||
        file.type === "image/bmp" ||
        file.type === "image/gif" ||
        file.type === "image/png"
      ) {
        logoType = true;
      }
      const isLt1M = file.size / 1024 / 1024 < 1;

      if (!logoType) {
        this.$message.error(
          "上传logo图片只能是 jpg / jpeg / bmp / gif / png 格式!"
        );
      }
      if (!isLt1M) {
        this.$message.error("上传logo图片大小不能超过 1MB!");
      }
      return logoType && isLt1M;
    },
    //上传图片
    toUploadImg(item) {
      let _ = this;
      let fd = new FormData();
      fd.append("file", item.file);
      _.$H.postFormData(_, _.$A.coupon.upload, fd).then((res) => {
        if (res.data.status === 200) {
          _.detailForm.pileImgUrl = res.data.data.viewPath || "";
          _.$U.success("图片上传成功！");
        }
      });
    },
    //删除上传图片
    handleRemove(file, fileList) {
      this.contractFile = null;
    },
    handlePreview(file) {
      console.log(file);
    },
    handleExceed(files, fileList) {
      // this.$message.warning(`当前限制选择 3 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`);
    },
    //删除附件前提示
    beforeRemove(file, fileList) {
      return this.$confirm(`确定移除 ${file.name}？`);
    },
    // 取消
    resetForm() {
      this.detailForm = {};
      this.$router.push({
        name: pageConfig.listRouter,
      });
    },
  },
};
</script>
